import styled from 'styled-components';

export const CustomizeAppearanceCardStyled = styled.div`
  .ot-wrap-reverser-badge-content {
    .Polaris-Badge {
      display: flex;
      flex-direction: row-reverse;
      .Polaris-Text--root {
        margin-right: 10px;
      }
    }
  }
`;
